import { RecommendationService } from '../services/recommendationService';
import { RecommendationEngine } from '../services/recommendationEngine';
import { TradingRulesService } from '../services/tradingRulesService';

import { StockService } from '../services/stockService';
import { PortfolioService } from '../services/portfolioService';
import { PositionService } from '../services/positionService';

// Test utility to debug recommendation generation
export const testRecommendations = async () => {
  console.log('=== Testing Recommendation System ===');
  
  try {
    // 1. Check if trading rules exist
    console.log('\n1. Checking trading rules...');
    const globalRules = await TradingRulesService.getGlobalRules();
    console.log('Global rules found:', globalRules ? 'YES' : 'NO');
    if (globalRules) {
      console.log('Rules summary:', {
        maxHoldingDays: globalRules.maxHoldingDays,
        defaultTrancheCount: globalRules.defaultTrancheCount,
        maxDistanceFromPivot: globalRules.maxDistanceFromPivot,
        minVolumeIncrease: globalRules.minVolumeIncrease
      });
    }
    
    // Check portfolios
    console.log('\n2. Checking portfolios...');
    const portfolios = await PortfolioService.getAllPortfolios();
    console.log(`Found ${portfolios.length} portfolios`);
    portfolios.forEach(p => {
      console.log(`- ${p.name}: ${p.isActive ? 'ACTIVE' : 'INACTIVE'}, Funds: $${p.availableFunds.toFixed(2)}`);
    });
    
    // Check watchlist
    console.log('\n3. Checking watchlist...');
    const watchlist = await StockService.getWatchlist();
    console.log(`Found ${watchlist.length} stocks in watchlist`);
    
    // Show first 5 with pivot data
    const withPivot = watchlist.filter(w => w.pivotPrice);
    console.log(`${withPivot.length} stocks have pivot prices`);
    
    withPivot.slice(0, 5).forEach(w => {
      console.log(`- ${w.symbol}: Current: $${w.currentPrice.toFixed(2)}, Pivot: $${w.pivotPrice?.toFixed(2)}, Distance: ${w.distanceFromPivot?.toFixed(2)}%`);
    });
    
    // 4. Generate recommendations directly from engine
    console.log('\n4. Generating recommendations from engine...');
    const engineRecs = await RecommendationEngine.generateRecommendations();
    console.log(`Engine generated ${engineRecs.length} recommendations`);
    
    if (engineRecs.length > 0) {
      console.log('\nFirst 3 recommendations:');
      engineRecs.slice(0, 3).forEach((rec, i) => {
        console.log(`\n${i + 1}. ${rec.type.toUpperCase()} - ${rec.symbol}`);
        console.log(`   Action: ${rec.action}`);
        console.log(`   Urgency: ${rec.urgency}`);
        console.log(`   Score: ${rec.score}`);
        console.log(`   Reasons:`, rec.reasons);
      });
    }
    
    // 3. Store recommendations via service
    console.log('\n3. Storing recommendations via service...');
    const storedRecs = await RecommendationService.generateAndStoreRecommendations('manual');
    console.log(`Service stored ${storedRecs.length} recommendations`);
    
    // 4. Retrieve active recommendations
    console.log('\n4. Retrieving active recommendations...');
    const activeRecs = await RecommendationService.getAllActiveRecommendations();
    console.log(`Found ${activeRecs.length} active recommendations in Firestore`);
    
    return {
      rulesExist: !!globalRules,
      engineGenerated: engineRecs.length,
      serviceStored: storedRecs.length,
      activeInFirestore: activeRecs.length,
      recommendations: engineRecs
    };
    
  } catch (error) {
    console.error('Test failed:', error);
    throw error;
  }
};

// Make it available on window for console testing
if (typeof window !== 'undefined') {
  (window as any).testRecommendations = testRecommendations;
}